import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./PreferencesPage.css";
import Navbar from "../../components/Navbar/Navbar";
import Button from "../../components/Button/Button";
import TransparentBox from '../../components/TransparentBox/TransparentBox';

function PreferencesPage() {
    const navigate = useNavigate();
    const [isTrackingOrder, setIsTrackingOrder] = useState(false);

    const handleLike = () => {
        // Add like handling logic
    };

    const handleDislike = () => {
        // Add dislike handling logic
    };

    const handleOrderStatus = () => {
        setIsTrackingOrder(true);
        // Navigate immediately to start the typing indicator in chat
        navigate("/chat", { state: { initialMessage: "Can you help me track my order from the last purchase?" } });
    };

    return (
        <div className="App">
            <Navbar />
            <main className="main-content">
                <TransparentBox onLike={handleLike} onDislike={handleDislike} />
                <div className="info-container">
                    <div className="info-icon-container">
                        <span className="info-icon">ⓘ</span>
                    </div>
                    <p className="info-text">
                        Our AI model is your
                        <span className="highlight"> New Shopping Friend!</span> Ask it anything sneaker related, and it
                        would give you the best options, sourced from all over.
                    </p>
                </div>
                <div className="button-container">
                    <Button
                        onClick={handleOrderStatus}
                        size="medium"
                        className="same-width"
                        loading={isTrackingOrder}
                        disabled={isTrackingOrder}
                    >
                        🔎 Track My Order
                    </Button>
                    <Button
                        onClick={() => navigate("/chat")}
                        size="medium"
                        className="same-width"
                    >
                        🤖 Tap to chat
                    </Button>
                </div>
            </main>
        </div>
    );
}

export default PreferencesPage;